import * as i0 from '@angular/core';
import { InjectionToken, inject, Injectable } from '@angular/core';
import { FLY_WEB_COMMON_CONFIG } from '@garmin-avcloud/avcloud-fly-web-common/config';
import { of, map, catchError } from 'rxjs';

//Scope values (the strings) are managed in oauth-admin. Altering this enum means there should be a correlating request in oauth-admin.
//Scope keys should try to match a `FEATURE_NAME_ACTION` pattern.
var Scope = /*#__PURE__*/function (Scope) {
  Scope["ACTIVATE_CCD_GRANT"] = "AVC_FLYADMIN_ACTIVATE_CCD_ADMIN_AUTHORIZE";
  Scope["ACTIVATE_OTC_GRANT"] = "AVC_FLYADMIN_ACTIVATE_OTC_REFRESH_ADMIN_AUTHORIZE";
  Scope["AIRCRAFT_DEVICES_DELETE"] = "AVC_FLYADMIN_REMOVE_DEVICES_ADMIN_AUTHORIZE";
  Scope["AIRCRAFT_MANAGEMENT_AIRCRAFT_MAKE_VIEW"] = "AVC_FLYADMIN_AIRCRAFT_MANAGEMENT_MAKE_ADMIN_READ";
  Scope["AIRCRAFT_MANAGEMENT_AIRCRAFT_MODEL_VIEW"] = "AVC_FLYADMIN_AIRCRAFT_MANAGEMENT_MODEL_ADMIN_READ";
  Scope["AIRCRAFT_LIBRARY_MAKES_VIEW"] = "AVC_FLYADMIN_VIEW_AIRCRAFT_MAKES_ADMIN_AUTHORIZE";
  Scope["AIRCRAFT_LIBRARY_MAKES_EDIT"] = "AVC_FLYADMIN_EDIT_AIRCRAFT_MAKES_ADMIN_AUTHORIZE";
  Scope["AIRCRAFT_LIBRARY_MODELS_VIEW"] = "AVC_FLYADMIN_VIEW_AIRCRAFT_MODELS_ADMIN_AUTHORIZE";
  Scope["AIRCRAFT_LIBRARY_MODELS_EDIT"] = "AVC_FLYADMIN_EDIT_AIRCRAFT_MODELS_ADMIN_AUTHORIZE";
  Scope["AIRCRAFT_LOGBOOK_ADMIN_READ"] = "AVC_FLYADMIN_AIRCRAFT_LOGBOOK_ADMIN_READ";
  Scope["AIRCRAFT_VIEW"] = "AVC_FLYADMIN_VIEW_AIRCRAFT_ADMIN_AUTHORIZE";
  Scope["AIRCRAFT_EDIT"] = "AVC_FLYADMIN_AIRCRAFT_ADMIN_UPDATE";
  Scope["AIRCRAFT_CREATE"] = "AVC_FLYADMIN_AIRCRAFT_ADMIN_CREATE";
  Scope["AIRCRAFT_TRANSFER"] = "AVC_FLYADMIN_AIRCRAFT_TRANSFER_ADMIN_AUTHORIZE";
  Scope["AVDB_SUBSCRIPTION_GRANT"] = "AVC_FLYADMIN_GRANT_AVDB_SUBSCRIPTIONS_ADMIN_AUTHORIZE";
  Scope["AVDB_SUBSCRIPTION_REVOKE"] = "AVC_FLYADMIN_YARMOUTH_SUBSCRIPTION_ADMIN_DELETE";
  Scope["AVDB_SUBSCRIPTION_UPDATE"] = "AVC_FLYADMIN_YARMOUTH_SUBSCRIPTIONS_ADMIN_UPDATE";
  Scope["HYDRA_BASELINE_SOFTWARE_VIEW"] = "AVC_FLYADMIN_AVIONICS_SOFTWARE_BASELINE_SOFTWARE_ADMIN_READ";
  Scope["HYDRA_BASELINE_SOFTWARE_EDIT"] = "AVC_FLYADMIN_AVIONICS_SOFTWARE_BASELINE_SOFTWARE_ADMIN_UPDATE";
  Scope["HYDRA_BASELINE_SOFTWARE_CREATE"] = "AVC_FLYADMIN_AVIONICS_SOFTWARE_BASELINE_SOFTWARE_ADMIN_CREATE";
  Scope["HYDRA_BASELINE_SOFTWARE_DELETE"] = "AVC_FLYADMIN_AVIONICS_SOFTWARE_BASELINE_SOFTWARE_ADMIN_DELETE";
  Scope["HYDRA_BASELINE_SOFTWARE_INSTALL_TARGETS_VIEW"] = "AVC_FLYADMIN_AVIONICS_SOFTWARE_INSTALL_TARGETS_BASELINE_SOFTWARE_ADMIN_READ";
  Scope["GP_DEVICE_REGISTRATION_VIEW"] = "AVC_FLYADMIN_VIEW_GP_DEVICE_REGISTRATIONS_ADMIN_AUTHORIZE";
  Scope["GP_DEVICE_REGISTRATION_EDIT"] = "AVC_FLYADMIN_MANAGE_GP_DEVICE_REGISTRATIONS_ADMIN_AUTHORIZE";
  Scope["GP_DEVICE_REGISTRATION_DELETE"] = "AVC_FLYADMIN_DELETE_GP_DEVICE_REGISTRATIONS_ADMIN_AUTHORIZE";
  Scope["GP_DEVICE_REGISTRATION_SEARCH"] = "AVC_FLYADMIN_SEARCH_GP_DEVICES_ADMIN_AUTHORIZE";
  Scope["GP_PROMO_CODE_REDEEM"] = "AVC_FLYADMIN_REDEEM_GP_SUBSCRIPTION_PROMO_CODE_ADMIN_AUTHORIZE";
  Scope["GP_SUBSCRIPTION_DEVICE_SLOT_DELETE"] = "AVC_FLYADMIN_DELETE_GP_SUBSCRIPTION_DEVICE_SLOT_ADMIN_AUTHORIZE";
  Scope["GP_SUBSCRIPTION_DEVICE_SLOT_CLAIM"] = "AVC_FLYADMIN_CLAIM_GP_SUBSCRIPTION_DEVICE_SLOT_ADMIN_AUTHORIZE";
  Scope["GP_SUBSCRIPTION_DEVICE_SLOT_VIEW"] = "AVC_FLYADMIN_VIEW_GP_SUBSCRIPTION_DEVICE_SLOT_ADMIN_AUTHORIZE";
  Scope["GP_SUBSCRIPTION_GRANT"] = "AVC_FLYADMIN_GRANT_GP_SUBSCRIPTIONS_ADMIN_AUTHORIZE";
  Scope["GP_SUBSCRIPTION_MANAGE"] = "AVC_FLYADMIN_MANAGE_GP_SUBSCRIPTIONS_ADMIN_AUTHORIZE";
  Scope["GP_SUBSCRIPTION_VIEW"] = "AVC_FLYADMIN_VIEW_GP_SUBSCRIPTION_MANAGEMENT_ADMIN_AUTHORIZE";
  Scope["ORGS_ROLES_ORGANIZATION_VIEW"] = "AVC_FLYADMIN_ORGS_ROLES_ORGANIZATIONS_ADMIN_READ";
  Scope["ORGS_ROLES_ORGANIZATION_CREATE"] = "AVC_FLYADMIN_ORGS_ROLES_ORGANIZATIONS_ADMIN_CREATE";
  Scope["ORGS_ROLES_ORGANIZATION_SEARCH"] = "AVC_FLYADMIN_ORGS_ROLES_ORGANIZATIONS_ADMIN_SEARCH";
  Scope["ORGS_ROLES_ORGANIZATION_SETTINGS_VIEW"] = "AVC_FLYADMIN_ORGS_ROLES_ORGANIZATIONS_SETTINGS_ADMIN_READ";
  Scope["ORGS_ROLES_ORGANIZATION_SETTINGS_EDIT"] = "AVC_FLYADMIN_ORGS_ROLES_ORGANIZATIONS_SETTINGS_ADMIN_UPDATE";
  Scope["ORGS_ROLES_ORGANIZATION_OWNERSHIP_EDIT"] = "AVC_FLYADMIN_ORGS_ROLES_ORGANIZATIONS_OWNERSHIP_ADMIN_UPDATE";
  Scope["ORGS_ROLES_MEMBERSHIP_VIEW"] = "AVC_FLYADMIN_ORGS_ROLES_MEMBERSHIP_ADMIN_READ";
  Scope["ORGS_ROLES_MEMBERSHIP_CREATE"] = "AVC_FLYADMIN_ORGS_ROLES_MEMBERSHIP_ADMIN_CREATE";
  Scope["ORGS_ROLES_MEMBERSHIP_DELETE"] = "AVC_FLYADMIN_ORGS_ROLES_MEMBERSHIP_ADMIN_DELETE";
  Scope["ORGS_ROLES_MEMBERSHIP_INVITES_VIEW"] = "AVC_FLYADMIN_ORGS_ROLES_MEMBERSHIP_INVITES_ADMIN_READ";
  Scope["ORGS_ROLES_MEMBERSHIP_INVITES_CREATE"] = "AVC_FLYADMIN_ORGS_ROLES_MEMBERSHIP_INVITES_ADMIN_CREATE";
  Scope["ORGS_ROLES_MEMBERSHIP_INVITES_DELETE"] = "AVC_FLYADMIN_ORGS_ROLES_MEMBERSHIP_INVITES_ADMIN_DELETE";
  Scope["ORGS_ROLES_ORGANIZATION_AIRCRAFT_VIEW"] = "AVC_FLYADMIN_ORGS_ROLES_ORGANIZATIONS_AIRCRAFT_ADMIN_READ";
  Scope["ORGS_CUSTOM_ROLES_EDIT"] = "AVC_FLYADMIN_EDIT_ORGANIZATIONS_CUSTOM_ROLES_ADMIN_AUTHORIZE";
  Scope["ORGS_CUSTOM_ROLES_VIEW"] = "AVC_FLYADMIN_VIEW_ORGANIZATIONS_CUSTOM_ROLES_ADMIN_AUTHORIZE";
  Scope["THIRD_PARTY_AUTH_REVOKE"] = "AVC_FLYADMIN_REVOKE_THIRD_PARTY_AUTH_ADMIN_AUTHORIZE";
  Scope["THIRD_PARTY_AUTH_VIEW"] = "AVC_FLYADMIN_VIEW_THIRD_PARTY_AUTH_ADMIN_AUTHORIZE";
  Scope["USER_CUSTOMER_GUID_SEARCH"] = "AVC_FLYADMIN_SEARCH_BY_CUSTOMER_GUID_ADMIN_AUTHORIZE";
  Scope["USER_EMAIL_SEARCH"] = "AVC_FLYADMIN_SEARCH_BY_CUSTOMER_EMAIL_ADMIN_AUTHORIZE";
  Scope["USER_PROFILE_VIEW"] = "AVC_FLYADMIN_VIEW_CUSTOMER_PROFILE_ADMIN_AUTHORIZE";
  Scope["USER_EMAIL_VIEW"] = "AVC_FLYADMIN_VIEW_CUSTOMER_EMAIL_ADMIN_AUTHORIZE";
  Scope["USER_NAME_VIEW"] = "AVC_FLYADMIN_VIEW_CUSTOMER_NAME_ADMIN_AUTHORIZE";
  Scope["TWILIO_MANAGEMENT_FEATURE"] = "AVC_FLYADMIN_TWILIO_MANAGEMENT_FEATURE_ADMIN_AUTHORIZE";
  Scope["TWILIO_MANAGEMENT_NUMBER_VIEW"] = "AVC_FLYADMIN_VIEW_TWILIO_NUMBER_AUTH_ADMIN_AUTHORIZE";
  Scope["TWILIO_MANAGEMENT_NUMBER_RELEASE"] = "AVC_FLYADMIN_RELEASE_TWILIO_NUMBER_AUTH_ADMIN_AUTHORIZE";
  Scope["TWILIO_MANAGEMENT_NUMBER_PROVISION"] = "AVC_FLYADMIN_PROVISION_TWILIO_NUMBER_AUTH_ADMIN_AUTHORIZE";
  return Scope;
}(Scope || {});
const SCOPE_AUTHORIZATION = new InjectionToken('SCOPE_AUTHORIZATION_TOKEN');
let ScopeService = /*#__PURE__*/(() => {
  class ScopeService {
    constructor() {
      this.config = inject(FLY_WEB_COMMON_CONFIG);
      this.scopeService = inject(SCOPE_AUTHORIZATION, {
        optional: true
      });
      if (this.config.site === 'FALA' && this.scopeService == null) {
        throw new Error('SCOPE_AUTHORIZATION must be provided for FALA');
      }
    }
    determinePrivilege(scope) {
      if (this.config.site === 'FGA') {
        return of(true);
      }
      return this.scopeService.hasScopes([scope]).pipe(map(scopes => scopes.every(s => s)), catchError(e => {
        console.error(`Unable to determine if user has Scope: ${scope}`, e);
        return of(false);
      }));
    }
    static {
      this.ɵfac = function ScopeService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ScopeService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ScopeService,
        factory: ScopeService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ScopeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API surface of `admin-authorization`
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SCOPE_AUTHORIZATION, Scope, ScopeService };
